/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询票夹列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.TicketFolderDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-folder/list`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
